import React from 'react';

// Components
import { FormattedMessageV2 } from '@/views/components/i18n';
import { RiskProfileDetails } from './components/RiskProfileDetails';
import { SharedEmails } from './components/SharedEmails';

// Enums
import { ALLOWED_HTML_TAGS } from '@/views/components/i18n/FormattedMessageV2';

// Types
import { Email } from '@/types/models/risk-profiles/omni-risk-profile-stats';
import { FormattedFullOmniRiskProfile } from '@/types/risk-profiles/omni/full-omni-risk-profile';

interface ReviewingInformationProps {
  authorizeEmail: (email: string) => Promise<void>;
  sharedEmails: Email[];
  riskProfile: FormattedFullOmniRiskProfile;
  showRiskProfileDetails?: boolean;
}

export const ReviewingInformation: React.FC<ReviewingInformationProps> = ({ authorizeEmail, riskProfile, sharedEmails, showRiskProfileDetails }) => (
  <div className="send-questionnaire-reviewing-information">
    <FormattedMessageV2
      className="label"
      tagName={ALLOWED_HTML_TAGS.P}
      toLocalize="RiskProfileModal.SendQuestionnaire.WhoHasAccess"
      values={{ count: sharedEmails.length ? 1 : 0 }} // TODO: This counter needs review once multiple emails are supported.
    />
    {!sharedEmails.length && (
      <FormattedMessageV2 className="empty-state" tagName={ALLOWED_HTML_TAGS.P} toLocalize="RiskProfileModal.SendQuestionnaire.NoAuthorizedUsers" />
    )}
    {!!sharedEmails.length && <SharedEmails authorizeEmail={authorizeEmail} riskProfile={riskProfile} />}
    {showRiskProfileDetails && <RiskProfileDetails riskProfile={riskProfile} />}
  </div>
);
